/**
 * @classdesc Thai Language Pack
 * @desc This class will used to translate tokens into the Thai language.
 * @namespace Languages.Thai
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Thai
 */
export const dictionary = {
	'years'   : 'ปี',
	'months'  : 'เดือน',
	'days'    : 'วัน',
	'hours'   : 'ชั่วโมง',
	'minutes' : 'นาที',
	'seconds' : 'วินาที'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Thai
 */
export const aliases = ['th', 'th-th', 'thai'];
